export const getApiUrl = (endpoint) => {
  const hostname = window.location.hostname;
  if (hostname === 'dcacrypto.pro') {
    return `https://qk5dcpjv9a.execute-api.ap-southeast-1.amazonaws.com${endpoint}`;
  } else {
    return `http://${hostname}${endpoint}`;
  }
};
